<template lang="html">
    <div id="weekplanInfo"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)"
    >
        <navBar :tags="tags"
                :title="titleName"
                :subTitle="subTitle"
                :btnAgree="agreedOnOff"
                :btnRefuse="refusedOnOff"
                :btnSubmit="submitOnOff"
                :btnSave="saveOnOff"
                :btnBack="true"
                @btnDeleteClick="btnDeleteClick"
                @btnAgreeClick="btnAgreeClick" @btnRefuseClick="btnRefuseClick" @btnSubmitClick="btnSubmitClick" @btnSaveClick="inputBtnSaveClick"  @btnBackClick="handleBackClick"/>
<!-- 删除按钮       :btnDelete="deleteOnOff"-->
        <!--        信息-->
        <div>
            <el-tabs v-model="activeName" @tab-click="handleTabClick" :before-leave="beforeHandle">
                <el-tab-pane label="计划汇总" name="first">
                    <div style="width: 70%;margin-top:10px;float: left;">
                        <el-form label-width="120px" :model="form" :disabled="onOff" ref="formWeekInfo">
                            <el-row>
                                <!--                    <el-col v-if=" status === 'INFO'">-->
                                <!--                        <el-form-item label="计划日期">-->
                                <!--                            <p style="margin: 0;color: #3998f7">{{form.datePlan}}</p>-->
                                <!--                        </el-form-item>-->
                                <!--                    </el-col>-->

                                <el-col>
                                    <el-form-item label="辖区" :rules="[{ required: true, message: '辖区不能为空'}]" prop="territory_name">
                                        <el-select :disabled="status === 'INFO'" v-model="form.territory_name" style="width: 100%" placeholder="请选择" clearable>
                                            <el-option
                                                    v-for="item in territoryArray"
                                                    :key="item.territory_id"
                                                    :label="item.territory_name"
                                                    :value="item.territory_id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>

                                <el-col>
                                    <el-form-item label="计划日期" :rules="[{ required: true, message: '计划日期不能为空'}]" prop="selectDate">
                                        <el-select :disabled="status === 'INFO'" v-model="datePlanTime" style="width: 100%" placeholder="请选择" clearable>
                                            <el-option
                                                    v-for="item in formSelectDate"
                                                    :key="item.startDate"
                                                    :label="item.start_end_time"
                                                    :value="item.startDate">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col>
                                    <el-form-item label="主要工作">
                                        <el-input type="textarea" :rows="6" class="weekPlanInfoInput" v-model="form.comments">
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col v-if="clientObj.showInstitution">
                                    <el-form-item label="医务拜访" class="institutionTitle">
<!--                                        <el-card v-if="!onOff" class="box-card" @click.native="openMedicalVisitModel">-->
<!--                                  <span  v-for="item,j in form.institutionsArray"-->
<!--                                         style="display: inline-block;-->
<!--                                          background: white;-->
<!--                                          color: #FF9901;padding: 0 6px;border:1px solid #FF9901;-->
<!--                                          margin-right: 10px;-->
<!--                                          border-radius: 6px;-->
<!--                                          line-height: 25px;font-size: 12px">-->
<!--                                      {{item.institution_name}}{{item.dept_name | titleFilter}}{{ item.hcp_name | titleFilter}}-->
<!--                                      </span>-->
<!--                                        </el-card>-->
                                        <el-card  class="box-card">
                                  <span  v-for="(item,j) in form.institutionsArray"
                                         style="display: inline-block;
                                          background: white;
                                          color: #FF9901;padding: 0 6px;border:1px solid #FF9901;
                                          margin-right: 10px;
                                          border-radius: 6px;
                                          line-height: 25px;font-size: 12px">
                                      {{item.activity_date | weekDayFilter}}{{item.institution_name}}{{item.dept_name | titleFilter}}{{ item.hcp_name | titleFilter}}
                                      </span>
                                        </el-card>
                                    </el-form-item>
                                </el-col>
                                <el-col v-if="clientObj.showStore">
                                    <el-form-item label="门店巡查" class="storeTitle">
<!--                                        <el-card v-if="!onOff" class="box-card" @click.native="openMedicalVisitModelStore">-->
<!--                                  <span  v-for="item,j in form.retailstoreArray"-->
<!--                                         style="display: inline-block;-->
<!--                                          background: #FF9901;-->
<!--                                          color: white;padding: 0 6px;-->
<!--                                          margin-right: 10px;-->
<!--                                          border-radius: 6px;-->
<!--                                          line-height: 25px;font-size: 12px">{{item.store_name}}-->
<!--                                      </span>-->
<!--                                        </el-card>-->
                                        <el-card  class="box-card">
                                  <span  v-for="(item,j) in form.retailstoreArray"
                                         style="display: inline-block;
                                          background: white;
                                          color: #FF9901;padding: 0 6px;border:1px solid #FF9901;
                                          margin-right: 10px;
                                          border-radius: 6px;
                                          line-height: 25px;font-size: 12px">{{item.activity_date | weekDayFilter}}{{item.store_name}}
                                      </span>
                                        </el-card>
                                    </el-form-item>
                                </el-col>
                                <el-col v-if="clientObj.showDistributor">
                                    <el-form-item label="商务拜访" class="distributorTitle">
<!--                                        <el-card v-if="!onOff" class="box-card" @click.native="openMedicalVisitModelDis">-->
<!--                                  <span  v-for="item,j in form.distributorArray"-->
<!--                                         style="display: inline-block;-->
<!--                                          background: #FF9901;-->
<!--                                          color: white;padding: 0 6px;-->
<!--                                          margin-right: 10px;-->
<!--                                          border-radius: 6px;-->
<!--                                          line-height: 25px;font-size: 12px">{{item.distributor_name}}{{item.job_title | titleFilter}}{{ item.contact_name | titleFilter}}-->
<!--                                      </span>-->
<!--                                        </el-card>-->
                                        <el-card  class="box-card">
                                  <span  v-for="(item,j) in form.distributorArray"
                                         style="display: inline-block;
                                          background: white;
                                          color: #FF9901;padding: 0 6px;border:1px solid #FF9901;
                                          margin-right: 10px;
                                          border-radius: 6px;
                                          line-height: 25px;font-size: 12px">{{item.activity_date | weekDayFilter}}{{item.distributor_name}}{{item.job_title | titleFilter}}{{ item.contact_name | titleFilter}}
                                      </span>
                                        </el-card>
                                    </el-form-item>
                                </el-col>
                                <el-col>
                                    <el-form-item label="会议/活动" class="meetingTitle">
<!--                                        <el-card v-if="!onOff" class="box-card" @click.native="openMedicalVisitModelMee">-->
<!--                                  <span  v-for="item,j in form.meetingArray"-->
<!--                                         style="display: inline-block;-->
<!--                                          background: #FF9901;-->
<!--                                          color: white;padding: 0 6px;-->
<!--                                          margin-right: 10px;-->
<!--                                          border-radius: 6px;-->
<!--                                          line-height: 25px;font-size: 12px">{{item.value1}}-->
<!--                                      </span>-->
<!--                                        </el-card>-->
                                        <el-card  class="box-card">
                                  <span  v-for="(item,j) in form.meetingArray"
                                         style="display: inline-block;
                                          background: white;
                                          color: #FF9901;padding: 0 6px;border:1px solid #FF9901;
                                          margin-right: 10px;
                                          border-radius: 6px;
                                          line-height: 25px;font-size: 12px">{{item.activity_date | weekDayFilter}}{{item.value1}}
                                      </span>
                                        </el-card>
                                    </el-form-item>
                                </el-col>
                                <el-col>
                                    <el-form-item label="辅导/协访" class="coachTitle">
                                        <el-card  class="box-card">
                                           <span  v-for="(item,j) in form.coachArray"
                                              style="display: inline-block;
                                              background: white;
                                              color: #FF9901;padding: 0 6px;border:1px solid #FF9901;
                                              margin-right: 10px;
                                              border-radius: 6px;
                                              line-height: 25px;font-size: 12px">{{item.activity_date | weekDayFilter}}{{item.value1}}
                                           </span>
                                        </el-card>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>

                    <!--        右侧留言-->
                    <div v-if="status === 'INFO'"
                         style="width: 27%;float: left;border:1px solid #DEDEDE;box-sizing: border-box;
                         background: #F4F6F8;margin-top:10px;margin-left:2.8%;border-radius: 8px;min-height: 640px;">
                        <el-row>
                            <el-button @click="openSavePlanModel"
                                       :class="['iconfont', 'el-icon-edit-outline',]" size="small"
                                       type="primary"
                                       style="float:right; height: 32px;padding: 8px 10px;
                               margin-top: 10px;margin-right: 10px;">
                                <i></i>写一笔</el-button>
                        </el-row>

                        <el-row style="overflow: auto">
                            <el-col v-for="(item,j) in form.psArray" style="padding: 5%;">
                                <div style="width: 30px;height: 30px;float: left;overflow: hidden;border-radius: 100%;
                                position: relative">
                                    <img v-if="item.src" :src="item.src"
                                         width="100%"
                                         alt="" style=" position: absolute;
                                            top:50%;
                                            left:50%;
                                            transform: translate(-50%,-50%);">
                                </div>
                                <div style="float:right;width: calc(100% - 50px)">
                                    <p style="margin-top:0%;margin-bottom:0%;color: #4D586D;font-size: 12px">{{item.last_name}}</p>
                                    <p :class="['iconfont','el-icon-time',]"
                                       style="color: #87909A;margin-top:5px;margin-bottom:0%;font-size: 12px;"><i></i>{{
                                        item.timestamp | componentFliter}}</p>
                                    <p style="white-space:normal;
                            margin-top:10px;margin-bottom:5%;
                            word-break:break-all;overflow:hidden;
                            width:90%;color: #4A4A4A;font-size: 13px;line-height: 20px">{{item.contents.comments}}</p>
                                </div>
                            </el-col>

                        </el-row>
                    </div>
                </el-tab-pane>
                <!-- <el-tab-pane :label="'不指定日期'+' ('+unAssign+')'" name="second" v-if="isShowTab">
                    <weekday ref="assignChild" :data="sendArray" @changeNum="changeNum" mapId="map1" @changeData="changeData" :selectDate="selectDate" :onOff="onOff" @sort="sort"></weekday>
                </el-tab-pane> -->
                <el-tab-pane :label="'周一'+' ('+MondayNum+')'" name="third">
                    <weekday1 ref="MonChild" :data="sendArray" @changeNum="changeNum" mapId="map2"  @changeData="changeData" :selectDate="selectDate" :onOff="onOff" @sort="sort"></weekday1>
                </el-tab-pane>
                <el-tab-pane :label="'周二'+' ('+TuesdayNum+')'" name="fourth">
                    <weekday2 ref="TuesChild" :data="sendArray" @changeNum="changeNum" mapId="map3"  @changeData="changeData" :selectDate="selectDate" :onOff="onOff" @sort="sort"></weekday2>
                </el-tab-pane>
                <el-tab-pane :label="'周三'+' ('+WednesdayNum+')'" name="fifth">
                    <weekday3  ref="WednesChild" :data="sendArray" @changeNum="changeNum" mapId="map4" @changeData="changeData" :selectDate="selectDate" :onOff="onOff" @sort="sort"></weekday3>
                </el-tab-pane>
                <el-tab-pane  :label="'周四'+' ('+ThursdayNum+')'" name="sixth">
                    <weekday4 ref="ThursChild" :data="sendArray" @changeNum="changeNum" mapId="map5" @changeData="changeData" :selectDate="selectDate" :onOff="onOff" @sort="sort"></weekday4>
                </el-tab-pane>
                <el-tab-pane  :label="'周五'+' ('+FridayNum+')'" name="seventh">
                    <weekday5 ref="FriChild" :data="sendArray" @changeNum="changeNum" mapId="map6" @changeData="changeData" :selectDate="selectDate" :onOff="onOff" @sort="sort"></weekday5>
                </el-tab-pane>
                <el-tab-pane :label="'周六'+' ('+SaturdayNum+')'" name="eighth">
                    <weekday6  ref="SaturChild" :data="sendArray" @changeNum="changeNum" mapId="map7" @changeData="changeData" :selectDate="selectDate" :onOff="onOff" @sort="sort"></weekday6>
                </el-tab-pane>
                <el-tab-pane :label="'周日'+' ('+SundayNum+')'" name="ninth">
                    <weekday7 ref="SunChild" :data="sendArray" @changeNum="changeNum" mapId="map8" @changeData="changeData" :selectDate="selectDate" :onOff="onOff" @sort="sort"></weekday7>
                </el-tab-pane>
            </el-tabs>


        </div>
        <el-dialog
                id="travelSavePlanPs"
                :visible.sync="modelSavePlanPs"
                :show-close="false"
                :before-close="handleClose"
                style="vertical-align: center;: #FFF9F3">
            <div style="">
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 10px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;padding-top: 8px;font-size: 20px">写一笔
                        </div>
                    </el-col>

                    <el-col :span="12">
                        <div align="right">
                            <el-button type="primary" size="small" @click="savePlanPs()">
                                保存
                            </el-button>
                            <el-button type="danger" size="small" @click="modelSavePlanPs = false">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div style="margin-top: 20px">
                <el-input type="textarea" v-model="contents"> </el-input>

            </div>
        </el-dialog>
    </div>
</template>

<script>
    import navBar from '../../../components/navBar'
    import http from '../../../APIService/http'
    import moment from 'moment'
    import noCheck from '../../../assets/images/noCheck.png'
    import inCheck from '../../../assets/images/speakers.png'
    import tou from '../../../assets/images/tou.png'
    import weekday from './components/weekday'
    import weekday1 from './components/weekday1'
    import weekday2 from './components/weekday2'
    import weekday3 from './components/weekday3'
    import weekday4 from './components/weekday4'
    import weekday5 from './components/weekday5'
    import weekday6 from './components/weekday6'
    import weekday7 from './components/weekday7'

    export default {
        name: "medical",
        data() {
            return {
                id: "",
                loading: false,
                tags: ['日程安排','周计划'],
                titleName: this.$store.getters.getUser.alias,
                title:this.$store.getters.getUser.role ==='staff' ? this.$store.getters.getUser.alias:'管理员',
                subTitle: '',
                data:{},
                datePlan:'',
                value1:[],
                noCheck : noCheck,
                inCheck : inCheck,
                territoryArray:[],
                form:{
                    territory_id:'',
                    territory_name:'',
                    datePlan:'',
                    comments:'',
                    distributorArray:[],
                    created_by:'',
                    end_date:'',
                    institutionsArray:[],
                    meetingArray:[],
                    coachArray:[],
                    plan_id:'',
                    psArray:[],
                    retailstoreArray:[],
                    start_date:'',
                    status:'',
                    datePlanTime:'',
                    datePlanInfo:'',
                    selectDate:''
                },
                datePlanTime:'',
                options:[
                    {
                        label:1,
                        value:1
                    },
                    {
                        label:2,
                        value:2
                    },
                    {
                        label:3,
                        value:3
                    }
                ],
                status:'',  //new新增  info详情
                modelSavePlanPs:false,
                medicalVisitModel:false,
                medicalVisitModelStore:false,
                medicalVisitModelDis:false,
                medicalVisitModelMee:false,
                institutionModel:{
                    institutionsArray:[],
                    instutionsHcpList:[]
                },
                storesArrayModel:[],
                disArrayModel:{
                    distributorArray:[],
                    contactArray:[]
                },
                meeArrayModel:[],
                copyInsArray:[],
                copyStoreArray:[],
                copyDisArray:[],
                copyMeeArray:[],
                contents:'',
                onOff:false,
                managerOnOff1:false,
                agreedOnOff:false,
                refusedOnOff:false,
                submitOnOff:false,
                saveOnOff:false,
                deleteOnOff:false,
                formSelectDate:[],
                pickerOptions: {
                    firstDayOfWeek:1,
                    disabledDate(time) {
                       let now =  moment().add('days',28).valueOf();
                        let weekOfday = moment(now).format('E')//获取在一周的第几天
                        let dateConstSunday = moment(now).subtract(weekOfday-7, 'days').valueOf()
                        return time.getTime() < Date.now() || time.getTime() > dateConstSunday ;

                    },
                },
                clientObj:{},
                activeName:'first',
                unAssign:0,
                MondayNum:0,
                TuesdayNum:0,
                WednesdayNum:0,
                ThursdayNum:0,
                FridayNum:0,
                SaturdayNum:0,
                SundayNum:0,
                unAssignArr:[],
                MondayArr:[],
                TuesdayArr:[],
                WednesdayArr:[],
                ThursdayArr:[],
                FridayArr:[],
                SaturdayArr:[],
                SundayArr:[],
                sendArray:[],
                copyForm:{},
                selectDate:'',
                isShowTab:true,
                deleteArr:[]

            }
        },
        filters:{
          componentFliter:function (value) {

              return moment(value).format('YYYY-M-D HH:mm:ss')
          },
          titleFilter:function (value) {
              if (value === undefined || value ===''){
                  return ''
              } else {
                  return '-'+value
              }
          },
          weekDayFilter: function(value){
              if(value==''||value==null){
                  return ''
              }else {
                  let dateObject = new Date(value)
                  let weekDay = dateObject.getDay()
                  switch (weekDay) {
                      case 1:
                          return '周一: '
                          break;
                      case 2:
                          return '周二: '
                          break;
                      case 3:
                          return '周三: '
                          break;
                      case 4:
                          return '周四: '
                          break;
                      case 5:
                          return '周五: '
                          break;
                      case 6:
                          return '周六: '
                          break;
                      case 0:
                          return '周日: '
                          break;
                  }
              }
          },
           filter_covegr:function (item) {
                if (item.calls == '0'&& item.campaigns == '0'){
                    return '本月尚未覆盖'
                } else {
                    let str =''
                    if (item.calls != '0'){
                        str = '本月已覆盖(医务拜访'
                    }
                    if (item.campaigns != '0'){
                        if (str != ''){
                            str = str + "、科室会"
                        } else {
                            str = str + "本月已覆盖(科室会"
                        }
                    }
                    if (str!=''){
                        str = str+")"
                    }
                    return str
                }
            }

        },
        computed:{
            // datePlanTime(){
            //     return this.form.datePlanTime
            // }
        },
        watch:{
            datePlanTime(newVal,oldVal){
                // console.log(newVal)
                let date = moment(newVal).format('YYYY-MM-DD')
                if(newVal !== ''){
                    this.form.selectDate = date
                }else{
                    this.form.selectDate = ''
                }

                let weekOfday = moment(date).format('E')//获取在一周的第几天
                let dateConst = moment(date).subtract(weekOfday-1, 'days').format('YYYY年MM月DD日');//周一日期
                this.form.start_date = moment(date).subtract(weekOfday-1, 'days').format('YYYY-MM-DD')
                this.form.end_date = moment(date).subtract(weekOfday-7, 'days').format('YYYY-MM-DD')
                if (this.status === 'NEW') {
                    let dateConstSunday = moment(date).subtract(weekOfday-7, 'days').format('YYYY年MM月DD日');//周日日期
                    if (newVal){
                        this.form.datePlanInfo = dateConst + '-' + dateConstSunday
                    }else {
                        this.form.datePlanInfo = ''
                    }

                }


            },
        },
        components: {
            navBar,
            weekday,
            weekday1,
            weekday2,
            weekday3,
            weekday4,
            weekday5,
            weekday6,
            weekday7,
            // Upload
        },
        created () {
            this.clientObj=this.$store.getters.getClient
        },
        async mounted () {
            if (this.$store.getters.getUser.role === "staff") {
                this.managerOnOff1 = false
            }else {
                this.managerOnOff1 = true
            }
            if (this.managerOnOff1 === true) {
                this.agreedOnOff=false
                this.refusedOnOff=false
                this.submitOnOff=false
                this.saveOnOff=false
                this.deleteOnOff = false
            }else {
                this.agreedOnOff=false
                this.refusedOnOff=false
                this.submitOnOff=false
                this.saveOnOff=false
            }
            // document.getElementById('main').scrollTo(0, 0)
            if(this.$route.params.type === 'new'){
                this.status = 'NEW'
                this.data = {}
                this.datePlan = ''
                this.subTitle = '创建周计划'
                // this.getInstutionsList()
                // this.getRetailstoreList()
                // this.getDistributorList()
                // this.getMeetingList()
                if (this.managerOnOff1 === true){
                    this.agreedOnOff=false
                    this.refusedOnOff=false
                    this.submitOnOff=true
                    this.saveOnOff=true
                } else {
                    this.submitOnOff=true
                    this.saveOnOff=true
                }
                await this.getTerritory()
            }else if (Object.keys(this.$route.params).length === 0){
                let condition = localStorage.getItem('condition')
                this.status = 'INFO'
                this.data =JSON.parse(condition)
                this.datePlan = this.data.time
                this.subTitle = this.data.time
                this.titleName = this.data.titleName
                await this.getTerritory()
                this.init()
            } else {
                this.status = 'INFO'
                this.data = this.$route.params
                this.datePlan = this.data.time
                this.subTitle = this.data.start_date?moment(this.data.start_date).format('YYYY年M月D日')+' - '+moment(this.data.end_date).format('M月D日'):this.data.time
                this.titleName = this.data.titleName
                await this.getTerritory()
                this.init()
            }
            console.log(this.data)
            this.isShowDate()
            this.getWeekPlanDate()
        },
        methods: {
            async init(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let data={
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        plan_id : this.data.plan_id
                    }

                    await http.post('/wapi/WeekPlan/getWeekPlanInfo',data).then(res=>{
                        if (res.success === true){
                            loading.close()
                            console.log(res.data,999)
                            //this.subTitle = moment(res.data.start_date).format('YYYY年MM月DD日') + '-' +
                            //     moment(res.data.end_date).format('MM月DD日')
                            let institutionsArray = res.data.institutionsArray
                            let meetingArray = res.data.meetingArray
                            let distributorArray = res.data.distributorArray
                            let retailstoreArray = res.data.retailstoreArray
                            let coachArray = res.data.coachArray
                            let hcpArray = []
                            let contactArray=[]
                            for (let i =0;i<institutionsArray.length;i++){
                                if (institutionsArray[i].reference_obj === 'HCP'){
                                    for (let j=0;j<institutionsArray[i].hcpArray.length;j++){
                                        institutionsArray[i].hcpArray[j].activity_category = 'HCP_CALL'
                                        institutionsArray[i].hcpArray[j].activity_type = ''
                                        institutionsArray[i].hcpArray[j].institution_id = institutionsArray[i].institution_id
                                        institutionsArray[i].hcpArray[j].institution_name = institutionsArray[i].institution_name
                                        institutionsArray[i].hcpArray[j].lng = institutionsArray[i].lng
                                        institutionsArray[i].hcpArray[j].lat = institutionsArray[i].lat
                                        hcpArray.push(institutionsArray[i].hcpArray[j])
                                    }
                                }else if (institutionsArray[i].reference_obj === 'INSTITUTION'){
                                    institutionsArray[i].activity_category = 'INSTITUTION_VISIT'
                                    institutionsArray[i].activity_type = ''
                                    hcpArray.push(institutionsArray[i])
                                }

                            }
                            for (let i =0;i<meetingArray.length;i++){
                                   meetingArray[i].activity_category = 'CAMPAIGN'
                                   meetingArray[i].reference_obj = ''
                                   meetingArray[i].reference_id = ''
                            }
                            for (let i =0;i<coachArray.length;i++){
                                coachArray[i].activity_category = 'COACHING'
                                coachArray[i].reference_obj = ''
                                coachArray[i].reference_id = ''
                            }
                            for (let i =0;i<distributorArray.length;i++){
                                if (distributorArray[i].reference_obj === 'DISTRIBUTOR') {
                                    distributorArray[i].activity_category = 'DISTRIBUTOR_VISIT'
                                    distributorArray[i].activity_type = ''
                                    contactArray.push(distributorArray[i])
                                }else if(distributorArray[i].reference_obj === 'CONTACT'){
                                    for (let j=0;j<distributorArray[i].contactArray.length;j++){
                                        distributorArray[i].contactArray[j].activity_category = 'CONTACT_CALL'
                                        distributorArray[i].contactArray[j].activity_type = ''
                                        distributorArray[i].contactArray[j].distributor_id = distributorArray[i].distributor_id
                                        distributorArray[i].contactArray[j].distributor_name = distributorArray[i].distributor_name
                                        distributorArray[i].contactArray[j].lng = distributorArray[i].lng
                                        distributorArray[i].contactArray[j].lat = distributorArray[i].lat
                                        contactArray.push(distributorArray[i].contactArray[j])
                                    }
                                }
                            }
                            for (let i =0;i<retailstoreArray.length;i++){
                                if (retailstoreArray[i].reference_obj === 'RETAILSTORE') {
                                    retailstoreArray[i].activity_category = 'STORE_INSPECTION'
                                    retailstoreArray[i].activity_type = ''
                                }
                            }
                            let allArray = hcpArray.concat(retailstoreArray,contactArray,meetingArray,coachArray)
                            for(let i=0;i<allArray.length;i++){
                                let obj = allArray[i]
                                let dateStr = obj.activity_date
                                if(dateStr==''||dateStr==null){
                                    this.unAssign+=1
                                    this.unAssignArr.push(obj)
                                }else {
                                    let dateObject = new Date(dateStr)
                                    let weekDay = dateObject.getDay()
                                    switch (weekDay) {
                                        case 1:
                                            this.MondayNum +=1
                                            this.MondayArr.push(obj)
                                            break;
                                        case 2:
                                            this.TuesdayNum+=1
                                            this.TuesdayArr.push(obj)
                                            break;
                                        case 3:
                                            this.WednesdayNum+=1
                                            this.WednesdayArr.push(obj)
                                            break;
                                        case 4:
                                            this.ThursdayNum+=1
                                            this.ThursdayArr.push(obj)
                                            break;
                                        case 5:
                                            this.FridayNum+=1
                                            this.FridayArr.push(obj)
                                            break;
                                        case 6:
                                            this.SaturdayNum+=1
                                            this.SaturdayArr.push(obj)
                                            break;
                                        case 0:
                                            this.SundayNum+=1
                                            this.SundayArr.push(obj)
                                            break;
                                    }
                                }
                            }
                            this.form = res.data
                            this.form.institutionsArray = hcpArray
                            this.form.distributorArray = contactArray
                            this.form.datePlan =moment(res.data.start_date).format('YYYY年M月D日') +' - '+moment(res.data.end_date).format('M月D日')
                            this.datePlanTime = moment(res.data.start_date).format('YYYY-MM-DD')
                            this.form.selectDate = this.datePlanTime
                            if(res.data.territory_id){
                                this.form.territory_id = res.data.territory_id
                                this.form.territory_name = this.territoryArray.find(e=>e.territory_id===res.data.territory_id).territory_name
                            }else{
                                if (this.territoryArray.length > 0) {
                                    this.form.territory_id = this.territoryArray[0].territory_id;
                                    this.form.territory_name = this.territoryArray[0].territory_name;
                                }
                            }
                            let timeInfo ={
                                startDate : res.data.start_date,
                                endDate : res.data.end_date,
                                start_end_time :moment(res.data.start_date).format('YYYY年M月D日') + ' - ' + moment(res.data.end_date).format('YYYY年M月D日')
                            }
                            let onoffSelectDate = true
                            for (let i = 0;i<this.formSelectDate.length;i++){
                                if (this.formSelectDate[i].startDate === timeInfo.startDate){
                                    onoffSelectDate = false
                                }
                            }
                            if (onoffSelectDate === true){
                                this.formSelectDate.push(timeInfo)
                            }

                            if (this.managerOnOff1 === true){ //如果是主管
                                if (this.form.created_by !== this.$store.getters.getUser.user_id) { //不是自己创建
                                    if (this.form.status === 'APPROVED' || this.form.status === 'DENIED' ) {
                                        this.agreedOnOff=false
                                        this.refusedOnOff=false
                                        this.onOff = true
                                    }else {
                                        this.agreedOnOff=true
                                        this.refusedOnOff=true
                                        this.onOff = true
                                    }

                                }else { //是自己创建
                                        this.agreedOnOff = false    //隐藏同意按钮
                                        this.refusedOnOff = false   //隐藏拒绝按钮
                                    if (this.form.status === 'SUBMITTED' || this.form.status === 'APPROVED'){
                                        //已提交和已完成 隐藏提交和保存和删除按钮
                                        this.saveOnOff = false
                                        this.submitOnOff = false
                                        this.onOff = true
                                        this.deleteOnOff = false
                                    } else {
                                        this.submitOnOff = true
                                        this.onOff = false
                                        this.saveOnOff = true
                                        this.deleteOnOff = true
                                    }
                                }
                            }

                            if (this.form.status === 'SUBMITTED' || this.form.status === 'APPROVED'){
                                if (this.managerOnOff1 === false){
                                    this.deleteOnOff = false
                                    this.submitOnOff=false
                                    this.saveOnOff=false
                                    this.onOff = true
                                }
                            }else {
                                if (this.managerOnOff1 === false){
                                    this.submitOnOff=true
                                    this.saveOnOff=true
                                    this.onOff = false
                                    this.deleteOnOff = true
                                }
                            }
                            let lastTimeStamp = moment(this.form.start_date).valueOf()
                            let nextTimeStamp = moment(this.form.end_date).valueOf()
                            let nowTimeStamp = moment(new Date()).valueOf()

                            if (nowTimeStamp > lastTimeStamp ) {
                                this.submitOnOff=false
                                this.saveOnOff=false
                                this.onOff = true
                                this.deleteOnOff = false
                            }
                            loading.close()
                            //获取头像照片
                            for (let j=0;j<this.form.psArray.length;j++){
                                if (this.form.psArray[j].photo_id){
                                    this.getImgUrl(this.form.psArray[j])
                                }else {
                                    this.form.psArray[j].src = tou
                                }
                            }
                            this.dealWithData()
                            this.copyForm = JSON.parse(JSON.stringify(this.form))
                        }


                    })

                }catch (e) {
                    loading.close()
                }
            },
            async isShowDate(){
                try{
                    let data={
                        tenant_id:this.$store.getters.getUser.tenant_id,
                    }
                    await http.post('/wapi/WeekPlan/isShowDate',data).then(res=>{
                        if(res.success){
                            this.isShowTab = res.data
                        }
                    })
                }catch (e) {
                }
            },
            async getTerritory(){
                var user_id =this.data && this.data.created_by?this.data.created_by: this.$store.getters.getUser.user_id;
                // let data ={
                //     user_id :user_id,
                //     tenant_id: this.$store.getters.getUser.tenant_id,
                // }

                // http.post('/wapi/WeekPlan/getTerritoryListByUser',data).then(res=>{
                //   if (res.success === true){
                //       this.territoryArray = res.data
                //       console.log(res.data)
                //       if (res.data.length > 0) {
                //             this.form.territory_id = res.data[0].key;
                //             this.form.territory_name = res.data[0].value1;
                //         }
                //   }else {

                //   }
                // })
                var user = this.$store.getters.getUser
                let data ={
                    user_id :user_id,
                    tenant_id: user.tenant_id,
                    search: this.queryString,
                    month : moment().format('YYYYMM'),
                    type : true,
                    isAdmin:false,
                    role : user.role
                }
                if (this.class_active){
                    data.type = true
                } else {
                    data.type = false
                }
                if (user.role === 'admin'){
                    data.isAdmin=true
                }

                await http.post('/wapi/Conference/getTerritory',data).then(res=>{
                  if (res.success === true){
                      this.territoryArray = res.data
                  }else {

                  }
                })
            },
            async getInstutionsList(){
                try {
                    let user = this.$store.getters.getUser
                    let data={
                        tenant_id: user.tenant_id,
                        user_id : user.user_id,
                        owner_id: user.user_id,
                        city_id : [],
                        grade_array: [],
                    }
                    await http.post('/wapi/WeekPlan/getInstutionsList',data).then(res=>{

                        let array1 =  res.data.array
                        let array2 = this.form.institutionsArray
                        let array3 = []
                        if (array2.length >0){
                            for (let i =0;i<array1.length;i++){
                                for (let j=0;j<array2.length;j++){
                                    array1[i].onoff = false
                                    if (array1[i].institution_id === array2[j].institution_id){
                                        array1[i].onoff = true
                                        break
                                    }
                                }
                            }
                        } else {
                            for (let i =0;i<array1.length;i++){
                                array1[i].onoff = false
                            }
                        }

                       this.institutionModel.institutionsArray = array1
                        //  this.institutionModel = institutionsArray
                        //  console.log(this.institutionModel,44)
                    })
                }catch (e) {

                }
            },
            handleBackClick(){
                this.$router.go(-1)
            },
            copyFn(obj) {

                if (obj == null) {
                    return null
                }
                var result = Array.isArray(obj) ? [] : {};
                for (let key in obj) {
                    if (obj.hasOwnProperty(key)) {
                        if (typeof obj[key] === 'object') {
                            result[key] = this.copyFn(obj[key]);  // 如果是对象，再次调用该方法自身
                        } else {
                            result[key] = obj[key];
                        }
                    }
                }
                return result;

            },

            inputBtnSaveClick(){
                this.$refs["formWeekInfo"].validate(valid=>{
                    console.log(valid)
                    if(!valid){
                        return false
                    }else {
                        this.btnSaveClick()
                    }
                })
            },
           async btnSaveClick(type){
                try {


                    let data = this.form
                    data.tenant_id = this.$store.getters.getUser.tenant_id
                    data.user_id = this.$store.getters.getUser.user_id
                    let distributorArray = data.distributorArray
                    let institutionsArray = data.institutionsArray
                    let retailstoreArray = data.retailstoreArray
                    let coachArray = data.coachArray
                    data.etms_activity_plan_detail=data.meetingArray.concat(distributorArray,institutionsArray,retailstoreArray,coachArray,this.deleteArr)
                    if (!data.start_date){
                        this.$message({
                            type:'error',
                            message:'请选择计划日期'
                        })
                        return false
                    }

                    if (!data.end_date){
                        this.$message({
                            type:'error',
                            message:'请选择计划日期'
                        })
                        return false
                    }
                    let loading = this.$loading({
                        lock: true,
                        text: '拼命加载中',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    await http.post('/wapi/WeekPlan/savaWeekPlanInfo',data).then(res=>{
                        if (this.status === 'NEW'){
                            this.status = 'INFO'
                        }
                        if (res.success === true){
                            if (!this.data.plan_id){
                                this.data = res.data[0]
                            }
                            //用户如果不保存直接提交 先保存成功在提交
                            if(type === 'submit'){
                                let obj={
                                    tenant_id : this.$store.getters.getUser.tenant_id,
                                    status : 'SUBMITTED',
                                    user_id : this.$store.getters.getUser.user_id,
                                    plan_id: this.data.plan_id
                                }
                                 http.post('/wapi/WeekPlan/submitWeekPlan',obj).then(res=>{
                                    if (res.success === true){
                                        //this.init()
                                        this.$message({
                                            type:'success',
                                            message:'提交成功'
                                        })
                                        this.$router.push({
                                            name:'weekPlan'
                                        })
                                        //loading.close()
                                    }

                                })
                            }else {
                                // loading.close()
                                // this.init()
                                this.$message({
                                    type:'success',
                                    message:'保存成功'
                                })
                                this.$router.push({
                                    name:'weekPlan'
                                })
                            }
                        }else {
                            loading.close()
                            this.$message({
                                type:'error',
                                message:'保存失败'
                            })
                        }

                    })
                }catch (e) {
                    loading.close()
                }
            },
            openSavePlanModel(){
                this.modelSavePlanPs= true
            },
            async savePlanPs(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let data={
                        type:'PLAN',
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        id:this.form.plan_id,
                        user_id : this.$store.getters.getUser.user_id,
                        contents:{
                            comments:this.contents,
                            photos:[]
                        }
                    }
                    await http.post('/wapi/Evection/savePlanPs',data).then(res=>{
                        if (res.success === true){
                            this.init()
                            this.$message({
                                type:'success',
                                message:'保存成功'
                            })
                            this.modelSavePlanPs= false
                            this.contents = ''
                            loading.close()
                        }

                    })
                } catch (e) {
                    loading.close()
                }

            },
            async btnSubmitClick(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let data={
                        tenant_id : this.$store.getters.getUser.tenant_id,
                        status : 'SUBMITTED',
                        user_id : this.$store.getters.getUser.user_id,
                        plan_id: this.form.plan_id
                    }
                    if (!(this.form.start_date)){
                        this.$message({
                            type:'error',
                            message: '请选择日期'
                        })
                        loading.close()
                        return false;
                    }
                    if (!(this.form.end_date)){
                        this.$message({
                            type:'error',
                            message: '请选择日期'
                        })
                        loading.close()
                        return false;
                    }
                    //用户如果不保存直接提交 先保存成功在提交
                    if (this.form.plan_id){
                        await http.post('/wapi/WeekPlan/submitWeekPlan',data).then(res=>{
                            if (res.success === true){
                                //this.init()
                                this.$message({
                                    type:'success',
                                    message:'提交成功'
                                })
                                this.$router.push({
                                    name:'weekPlan'
                                })
                            }

                        })
                    } else {
                        this.btnSaveClick('submit')
                    }

                }catch (e) {
                    loading.close()
                }
            },
            async btnAgreeClick(){
                try {
                    let data={
                        status:'APPROVED',
                        user_id:this.$store.getters.getUser.user_id,
                        plan_id: this.form.plan_id,
                        tenant_id : this.$store.getters.getUser.tenant_id,
                    }
                    await http.post('/wapi/WeekPlan/submitWeekPlan',data).then(res=>{
                        if (res.success === true){
                            this.$message({
                                type:'success',
                                message:'批准成功'
                            })
                            this.$router.push({
                                name:'weekPlan'
                            })
                            //this.init()
                        }
                    })

                }catch (e) {

                }
            },
            async btnDeleteClick(){
                this.$confirm('确认删除计划?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    try {
                        let data = this.form
                        data.tenant_id = this.$store.getters.getUser.tenant_id
                        data.user_id = this.$store.getters.getUser.user_id
                        data.submit = 'del'
                        await http.post('/wapi/WeekPlan/savaWeekPlanInfo',data).then(res=>{
                            if (res.success === true){
                                this.$message({
                                    type:'success',
                                    message:'删除成功'
                                })
                                this.$router.go(-1)
                            }
                        })
                    }  catch (e) {

                    }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            async btnRefuseClick(){
                try {
                    let data={
                        status:'DENIED',
                        user_id:this.$store.getters.getUser.user_id,
                        plan_id: this.form.plan_id,
                        tenant_id : this.$store.getters.getUser.tenant_id,
                    }
                    await http.post('/wapi/WeekPlan/submitWeekPlan',data).then(res=>{
                        if (res.success === true){
                            this.$message({
                                type:'success',
                                message:'批准成功'
                            })
                            this.$router.push({
                                name:'weekPlan'
                            })
                            //this.init()
                        }

                    })
                }catch (e) {

                }
            },
            colorFun(item){
                if (item.calls == '0' && item.campaigns == "0"){
                    return '#ED3B3F'
                } else {
                    return '#4A90E2'
                }
            },
            async getWeekPlanDate(){
                try {
                    let data ={
                        tenant_id : this.$store.getters.getUser.tenant_id,
                        user_id : this.$store.getters.getUser.user_id
                    }
                    await http.post('/wapi/WeekPlan/getWeekPlanDate',data).then(res=>{
                        if (res.success === true){
                            this.formSelectDate = res.data
                            for (let i =0;i<this.formSelectDate.length;i++){
                                let startDate = moment(this.formSelectDate[i].startDate).format('YYYY年M月D日')
                                let endDate = moment(this.formSelectDate[i].endDate).format('YYYY年M月D日')
                                this.formSelectDate[i].start_end_time = startDate + ' - ' + endDate
                            }
                            // console.log(res.data)
                        }
                    })
                }catch (e) {

                }
            },
            beforeHandle(){
                if(this.datePlanTime==''){
                    return false
                }
            },
            handleTabClick(tab){
                if(this.datePlanTime==''){
                    this.$message.error('请先选择计划日期')
                }
                 if(tab.name == 'second'){
                    this.selectDate = ''
                    this.unAssignArr.sort(this.compare('sort'))
                    this.sendArray = this.unAssignArr
                    this.$refs.assignChild.init(this.sendArray)
                    this.activeName = 'second'
                }else if(tab.name == 'third'){
                    this.selectDate = this.datePlanTime
                     this.MondayArr.sort(this.compare('sort'))
                    this.sendArray = this.MondayArr
                    this.$refs.MonChild.init(this.sendArray)
                    this.activeName = 'third'
                }else if(tab.name == 'fourth'){
                    this.selectDate = moment(this.datePlanTime).add(1, 'days').format('YYYY-MM-DD')
                     this.TuesdayArr.sort(this.compare('sort'))
                    this.sendArray = this.TuesdayArr
                     this.$refs.TuesChild.init(this.sendArray);
                    this.activeName = 'fourth'
                }else if(tab.name == 'fifth'){
                    this.selectDate = moment(this.datePlanTime).add(2, 'days').format('YYYY-MM-DD')
                     this.WednesdayArr.sort(this.compare('sort'))
                    this.sendArray = this.WednesdayArr
                    this.$refs.WednesChild.init(this.sendArray)
                    this.activeName = 'fifth'
                }else if(tab.name == 'sixth'){
                    this.selectDate = moment(this.datePlanTime).add(3, 'days').format('YYYY-MM-DD')
                     this.ThursdayArr.sort(this.compare('sort'))
                    this.sendArray = this.ThursdayArr
                     this.$refs.ThursChild.init(this.sendArray)
                     this.activeName = 'sixth'
                }else if(tab.name == 'seventh'){
                    this.selectDate = moment(this.datePlanTime).add(4, 'days').format('YYYY-MM-DD')
                     this.FridayArr.sort(this.compare('sort'))
                    this.sendArray = this.FridayArr
                     this.$refs.FriChild.init(this.sendArray)
                     this.activeName = 'seventh'
                }else if(tab.name == 'eighth'){
                    this.selectDate = moment(this.datePlanTime).add(5, 'days').format('YYYY-MM-DD')
                     this.SaturdayArr.sort(this.compare('sort'))
                    this.sendArray = this.SaturdayArr
                     this.$refs.SaturChild.init(this.sendArray)
                     this.activeName = 'eighth'
                }else if(tab.name == 'ninth'){
                    this.selectDate = moment(this.datePlanTime).add(6, 'days').format('YYYY-MM-DD')
                     this.SundayArr.sort(this.compare('sort'))
                    this.sendArray = this.SundayArr
                     this.$refs.SunChild.init(this.sendArray)
                     this.activeName = 'ninth'
                }
            },
            changeNum(item){
                //计数要相应改变
                if(this.activeName == 'second'){
                    this.unAssign -=1
                }else if(this.activeName == 'third'){
                    this.MondayNum -=1
                }else if(this.activeName == 'fourth'){
                    this.TuesdayNum -=1
                }else if(this.activeName == 'fifth'){
                    this.WednesdayNum -=1
                }else if(this.activeName == 'sixth'){
                    this.ThursdayNum -=1
                }else if(this.activeName == 'seventh'){
                    this.FridayNum -=1
                }else if(this.activeName == 'eighth'){
                    this.SaturdayNum -=1
                }else if(this.activeName == 'ninth'){
                    this.SundayNum -=1
                }
                //汇总地方要删除
                if(item.activity_category == 'HCP_CALL' ||item.activity_category == 'INSTITUTION_VISIT'){
                    for(let i=0;i<this.form.institutionsArray.length;i++){
                        let obj = this.form.institutionsArray[i]
                        if(obj.reference_id == item.reference_id){
                            this.form.institutionsArray.splice(i,1)
                            break
                        }
                    }
                }else if(item.activity_category == 'STORE_INSPECTION'){
                    for(let i=0;i<this.form.retailstoreArray.length;i++){
                        let obj = this.form.retailstoreArray[i]
                        if(obj.reference_id == item.reference_id){
                            this.form.retailstoreArray.splice(i,1)
                            break
                        }
                    }
                }else if(item.activity_category == 'CONTACT_CALL' ||item.activity_category == 'DISTRIBUTOR_VISIT'){
                    for(let i=0;i<this.form.distributorArray.length;i++){
                        let obj = this.form.distributorArray[i]
                        if(obj.reference_id == item.reference_id){
                            this.form.distributorArray.splice(i,1)
                            break
                        }
                    }
                }else if(item.activity_category == 'CAMPAIGN'){
                    for(let i=0;i<this.form.meetingArray.length;i++){
                        let obj = this.form.meetingArray[i]
                        if(obj.reference_id == item.reference_id){
                            this.form.meetingArray.splice(i,1)
                            break
                        }
                    }
                }else if(item.activity_category == 'COACHING'){
                    for(let i=0;i<this.form.coachArray.length;i++){
                        let obj = this.form.coachArray[i]
                        if(obj.reference_id == item.reference_id){
                            this.form.coachArray.splice(i,1)
                            break
                        }
                    }
                }
                if(item.key_id){
                    item.delete = 'T'
                    this.deleteArr.push(item)
                }
                this.dealWithData()
            },
            changeData(array,dataArr){
                if(array[0].activity_category =='HCP_CALL'||array[0].activity_category =='INSTITUTION_VISIT'){
                    this.insFunction(array,dataArr)
                }else if(array[0].activity_category =='STORE_INSPECTION'){
                    this.storeFunction(array,dataArr)
                }else if(array[0].activity_category =='CONTACT_CALL'||array[0].activity_category =='DISTRIBUTOR_VISIT'){
                    this.disFunction(array,dataArr)
                }else if(array[0].activity_category =='CAMPAIGN'){
                    this.meetFunction(array,dataArr)
                }else if(array[0].activity_category =='COACHING'){
                    this.coachFunction(array,dataArr)
                }
            },
            insFunction(array,dataArr){
                if(this.activeName=='second'){
                    let list = this.form.institutionsArray.filter(items => {
                        if (!this.unAssignArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.unAssignArr.includes(items)) return items;
                    })
                    this.form.institutionsArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.unAssign =  this.sendArray.length
                }else if(this.activeName=='third'){
                    let list = this.form.institutionsArray.filter(items => {
                        if (!this.MondayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.MondayArr.includes(items)) return items;
                    })
                    this.form.institutionsArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.MondayNum =  this.MondayArr.length
                }else if(this.activeName=='fourth'){
                    let list = this.form.institutionsArray.filter(items => {
                        if (!this.TuesdayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.TuesdayArr.includes(items)) return items;
                    })
                    this.form.institutionsArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.TuesdayNum =  this.TuesdayArr.length
                }else if(this.activeName=='fifth'){
                    let list = this.form.institutionsArray.filter(items => {
                        if (!this.WednesdayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.WednesdayArr.includes(items)) return items;
                    })
                    this.form.institutionsArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.WednesdayNum =  this.WednesdayArr.length
                }else if(this.activeName=='sixth'){
                    let list = this.form.institutionsArray.filter(items => {
                        if (!this.ThursdayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.ThursdayArr.includes(items)) return items;
                    })
                    this.form.institutionsArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.ThursdayNum =  this.ThursdayArr.length
                }else if(this.activeName=='seventh'){
                    let list = this.form.institutionsArray.filter(items => {
                        if (!this.FridayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.FridayArr.includes(items)) return items;
                    })
                    this.form.institutionsArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.FridayNum =  this.FridayArr.length
                }else if(this.activeName=='eighth'){
                    let list = this.form.institutionsArray.filter(items => {
                        if (!this.SaturdayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.SaturdayArr.includes(items)) return items;
                    })
                    this.form.institutionsArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.SaturdayNum =  this.SaturdayArr.length
                }
                else if(this.activeName=='ninth'){
                    let list = this.form.institutionsArray.filter(items => {
                        if (!this.SundayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.SundayArr.includes(items)) return items;
                    })
                    this.form.institutionsArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.SundayNum =  this.SundayArr.length
                }
            },
            storeFunction(array,dataArr){
                if(this.activeName=='second'){
                    let list = this.form.retailstoreArray.filter(items => {
                        if (!this.unAssignArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.unAssignArr.includes(items)) return items;
                    })
                    this.form.retailstoreArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.unAssign =  this.sendArray.length
                }else if(this.activeName=='third'){
                    let list = this.form.retailstoreArray.filter(items => {
                        if (!this.MondayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.MondayArr.includes(items)) return items;
                    })
                    this.form.retailstoreArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.MondayNum =  this.MondayArr.length
                }else if(this.activeName=='fourth'){
                    let list = this.form.retailstoreArray.filter(items => {
                        if (!this.TuesdayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.TuesdayArr.includes(items)) return items;
                    })
                    this.form.retailstoreArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.TuesdayNum =  this.TuesdayArr.length
                }else if(this.activeName=='fifth'){
                    let list = this.form.retailstoreArray.filter(items => {
                        if (!this.WednesdayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.WednesdayArr.includes(items)) return items;
                    })
                    this.form.retailstoreArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.WednesdayNum =  this.WednesdayArr.length
                }else if(this.activeName=='sixth'){
                    let list = this.form.retailstoreArray.filter(items => {
                        if (!this.ThursdayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.ThursdayArr.includes(items)) return items;
                    })
                    this.form.retailstoreArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.ThursdayNum =  this.ThursdayArr.length
                }else if(this.activeName=='seventh'){
                    let list = this.form.retailstoreArray.filter(items => {
                        if (!this.FridayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.FridayArr.includes(items)) return items;
                    })
                    this.form.retailstoreArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.FridayNum =  this.FridayArr.length
                }else if(this.activeName=='eighth'){
                    let list = this.form.retailstoreArray.filter(items => {
                        if (!this.SaturdayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.SaturdayArr.includes(items)) return items;
                    })
                    this.form.retailstoreArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.SaturdayNum =  this.SaturdayArr.length
                }
                else if(this.activeName=='ninth'){
                    let list = this.form.retailstoreArray.filter(items => {
                        if (!this.SundayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.SundayArr.includes(items)) return items;
                    })
                    this.form.retailstoreArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.SundayNum =  this.SundayArr.length
                }
            },
            disFunction(array,dataArr){
                if(this.activeName=='second'){
                    let list = this.form.distributorArray.filter(items => {
                        if (!this.unAssignArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.unAssignArr.includes(items)) return items;
                    })
                    this.form.distributorArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.unAssign =  this.sendArray.length
                }else if(this.activeName=='third'){
                    let list = this.form.distributorArray.filter(items => {
                        if (!this.MondayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.MondayArr.includes(items)) return items;
                    })
                    this.form.distributorArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.MondayNum =  this.MondayArr.length
                }else if(this.activeName=='fourth'){
                    let list = this.form.distributorArray.filter(items => {
                        if (!this.TuesdayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.TuesdayArr.includes(items)) return items;
                    })
                    this.form.distributorArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.TuesdayNum =  this.TuesdayArr.length
                }else if(this.activeName=='fifth'){
                    let list = this.form.distributorArray.filter(items => {
                        if (!this.WednesdayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.WednesdayArr.includes(items)) return items;
                    })
                    this.form.distributorArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.WednesdayNum =  this.WednesdayArr.length
                }else if(this.activeName=='sixth'){
                    let list = this.form.distributorArray.filter(items => {
                        if (!this.ThursdayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.ThursdayArr.includes(items)) return items;
                    })
                    this.form.distributorArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.ThursdayNum =  this.ThursdayArr.length
                }else if(this.activeName=='seventh'){
                    let list = this.form.distributorArray.filter(items => {
                        if (!this.FridayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.FridayArr.includes(items)) return items;
                    })
                    this.form.distributorArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.FridayNum =  this.FridayArr.length
                }else if(this.activeName=='eighth'){
                    let list = this.form.distributorArray.filter(items => {
                        if (!this.SaturdayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.SaturdayArr.includes(items)) return items;
                    })
                    this.form.distributorArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.SaturdayNum =  this.SaturdayArr.length
                }
                else if(this.activeName=='ninth'){
                    let list = this.form.distributorArray.filter(items => {
                        if (!this.SundayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.SundayArr.includes(items)) return items;
                    })
                    this.form.distributorArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.SundayNum =  this.SundayArr.length
                }
            },
            meetFunction(array,dataArr){
                if(this.activeName=='second'){
                    let list = this.form.meetingArray.filter(items => {
                        if (!this.unAssignArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.unAssignArr.includes(items)) return items;
                    })
                    this.form.meetingArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.unAssign =  this.sendArray.length
                }else if(this.activeName=='third'){
                    let list = this.form.meetingArray.filter(items => {
                        if (!this.MondayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.MondayArr.includes(items)) return items;
                    })
                    this.form.meetingArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.MondayNum =  this.MondayArr.length
                }else if(this.activeName=='fourth'){
                    let list = this.form.meetingArray.filter(items => {
                        if (!this.TuesdayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.TuesdayArr.includes(items)) return items;
                    })
                    this.form.meetingArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.TuesdayNum =  this.TuesdayArr.length
                }else if(this.activeName=='fifth'){
                    let list = this.form.meetingArray.filter(items => {
                        if (!this.WednesdayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.WednesdayArr.includes(items)) return items;
                    })
                    this.form.meetingArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.WednesdayNum =  this.WednesdayArr.length
                }else if(this.activeName=='sixth'){
                    let list = this.form.meetingArray.filter(items => {
                        if (!this.ThursdayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.ThursdayArr.includes(items)) return items;
                    })
                    this.form.meetingArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.ThursdayNum =  this.ThursdayArr.length
                }else if(this.activeName=='seventh'){
                    let list = this.form.meetingArray.filter(items => {
                        if (!this.FridayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.FridayArr.includes(items)) return items;
                    })
                    this.form.meetingArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.FridayNum =  this.FridayArr.length
                }else if(this.activeName=='eighth'){
                    let list = this.form.meetingArray.filter(items => {
                        if (!this.SaturdayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.SaturdayArr.includes(items)) return items;
                    })
                    this.form.meetingArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.SaturdayNum =  this.SaturdayArr.length
                }
                else if(this.activeName=='ninth'){
                    let list = this.form.meetingArray.filter(items => {
                        if (!this.SundayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.SundayArr.includes(items)) return items;
                    })
                    this.form.meetingArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.SundayNum =  this.SundayArr.length
                }
            },
            coachFunction(array,dataArr){
                if(this.activeName=='second'){
                    let list = this.form.coachArray.filter(items => {
                        if (!this.unAssignArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.unAssignArr.includes(items)) return items;
                    })
                    this.form.coachArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.unAssign =  this.sendArray.length
                }else if(this.activeName=='third'){
                    let list = this.form.coachArray.filter(items => {
                        if (!this.MondayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.MondayArr.includes(items)) return items;
                    })
                    this.form.coachArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.MondayNum =  this.MondayArr.length
                }else if(this.activeName=='fourth'){
                    let list = this.form.coachArray.filter(items => {
                        if (!this.TuesdayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.TuesdayArr.includes(items)) return items;
                    })
                    this.form.coachArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.TuesdayNum =  this.TuesdayArr.length
                }else if(this.activeName=='fifth'){
                    let list = this.form.coachArray.filter(items => {
                        if (!this.WednesdayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.WednesdayArr.includes(items)) return items;
                    })
                    this.form.coachArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.WednesdayNum =  this.WednesdayArr.length
                }else if(this.activeName=='sixth'){
                    let list = this.form.coachArray.filter(items => {
                        if (!this.ThursdayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.ThursdayArr.includes(items)) return items;
                    })
                    this.form.coachArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.ThursdayNum =  this.ThursdayArr.length
                }else if(this.activeName=='seventh'){
                    let list = this.form.coachArray.filter(items => {
                        if (!this.FridayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.FridayArr.includes(items)) return items;
                    })
                    this.form.coachArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.FridayNum =  this.FridayArr.length
                }else if(this.activeName=='eighth'){
                    let list = this.form.coachArray.filter(items => {
                        if (!this.SaturdayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.SaturdayArr.includes(items)) return items;
                    })
                    this.form.coachArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.SaturdayNum =  this.SaturdayArr.length
                }
                else if(this.activeName=='ninth'){
                    let list = this.form.coachArray.filter(items => {
                        if (!this.SundayArr.includes(items)) return items;
                    })
                    let list1 = array.filter(items => {
                        if (!this.SundayArr.includes(items)) return items;
                    })
                    this.form.coachArray = list.concat(array)
                    let sortArr = dataArr.concat(list1)
                    this.sort(sortArr)
                    this.SundayNum =  this.SundayArr.length
                }
            },
            sort(array){
               array.forEach((item,index)=>{
                   item.sort = index
               })
                if(this.activeName == 'second'){
                   this.unAssignArr = array
                   this.sendArray =  this.unAssignArr
                   this.$refs.assignChild.init(this.sendArray)
                }else if(this.activeName == 'third'){
                    this.MondayArr = array
                    this.sendArray =  this.MondayArr
                    this.$refs.MonChild.init(this.sendArray)
                }else if(this.activeName == 'fourth'){
                    this.TuesdayArr = array
                    this.sendArray =  this.TuesdayArr
                    this.$refs.TuesChild.init(this.sendArray)
                }else if(this.activeName == 'fifth'){
                    this.WednesdayArr = array
                    this.sendArray =  this.WednesdayArr
                    this.$refs.WednesChild.init(this.sendArray)
                }else if(this.activeName == 'sixth'){
                    this.ThursdayArr = array
                    this.sendArray =  this.ThursdayArr
                    this.$refs.ThursChild.init(this.sendArray)
                }else if(this.activeName == 'seventh'){
                    this.FridayArr = array
                    this.sendArray =  this.FridayArr
                    this.$refs.FriChild.init(this.sendArray)
                }else if(this.activeName == 'eighth'){
                    this.SaturdayArr = array
                    this.sendArray =  this.SaturdayArr
                    this.$refs.SaturChild.init(this.sendArray)
                }else if(this.activeName == 'ninth'){
                    this.SundayArr = array
                    this.sendArray =  this.SundayArr
                    this.$refs.SunChild.init(this.sendArray)
                }
                this.dealWithData()
            },
            compare(property){
                return function(a,b){
                    let value1 = a[property];
                    let value2 = b[property];
                    return value1 - value2;
                }
            },
            dealWithData(){
                this.form.institutionsArray.sort(this.dateCompare())
                this.form.distributorArray.sort(this.dateCompare())
                this.form.retailstoreArray.sort(this.dateCompare())
                this.form.meetingArray.sort(this.dateCompare())
                this.form.coachArray.sort(this.dateCompare())
            },
            dateCompare(){
                return function(a,b){
                    var value1 = a.activity_date;
                    var value2 = b.activity_date;
                    if(value1!==value2){
                        if(value1==''){
                            value1=0
                        }
                        if(value2==''){
                            value2=0
                        }
                        return Date.parse(value1) - Date.parse(value2)
                    }else{
                        return a.sort - b.sort
                    }
                }
            },
            // 获取图片id
            async getImgUrl(obj) {
                try {
                    // console.log(obj)
                    let data = {
                        reference_obj: 'INSTITUTION',
                        reference_id: 'com.saasyun.android',
                        credential: '0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4',
                        photo_ids: obj.photo_id,
                        tenant_id: this.$store.getters.getUser.tenant_id
                    }

                    let res = await http.post('/photos/downloadphotos', data)
                    let array = res.data


                    if (array.length > 0) {
                        obj.src = array[0].thu_url
                        this.$forceUpdate()
                    }

                } catch (err) {
                    console.log(`error:${err}`)
                }
            },
            handleClose(){

            },
        }
    }
</script>

<style scoped>
    /*#container {*/
    /*    background: #fff;*/
    /*    padding: 0px 50px;*/
    /*    height: 100%;*/
    /*    box-sizing: border-box;*/
    /*}*/
    #weekplanInfo{
        height: 100%;
    }
    #weekplanInfo >>>.el-form-item__label{
        font-size: 16px;
        color: #000000;
        padding-left: 0px;
        text-align: left;
        padding-right: 40px;
    }
    #weekplanInfo >>>.el-table_1_column_7{
        color: #3b99f7;
    }
    #weekplanInfo >>>.el-table th{
        padding: 7px 0px;
    }
    #weekplanInfo >>>.el-table td{
        padding: 7px 0px;
    }
    #weekplanInfo .box-card {
        width: 100%;
        box-shadow:none;
        min-height:40px;
    }
    #weekplanInfo >>> .el-icon-edit-outline:before{
        margin-right: 5px;
    }
    #weekplanInfo >>> .el-icon-time:before{
        margin-right: 5px;
    }
    #weekplanInfo >>>.el-icon-edit-outline:before {
        font-size: 16px;
    }
    #weekplanInfo >>>.el-icon-edit-outline span{
        position: relative;
        top: -2px;
        font-size: 13px;
    }
    #weekplanInfo .institutionTitle >>> .el-form-item__label{
        color: #59C95D;
    }
    #weekplanInfo .distributorTitle >>> .el-form-item__label{
        color: #F65272;
    }
    #weekplanInfo .storeTitle >>> .el-form-item__label{
        color: #FE8D40;
    }
    #weekplanInfo .meetingTitle >>> .el-form-item__label{
        color: #9A3BFE;
    }
    #weekplanInfo .coachTitle >>> .el-form-item__label{
        color: #2689F7;
    }

</style>

<style>
    #weekplanInfo .el-card__body{
        padding: 0px 20px 5px;
    }
    #weekplanInfo #travelSavePlanPs .el-textarea__inner{
        height: 400px;
    }
    #weekplanInfo .weekPlanInfoInput .el-input__inner{
        border: 1px solid #EBEEF5;
    }
    #weekplanInfo .el-dialog__header{
        padding: 0px;
    }
    [v-cloak] {
        display: none;
    }
    #weekplanInfo .el-button--warning {
        color: #FFF;
        background-color: #FF9901;
        border-color: #FF9901;
    }
    #weekplanInfo .el-button--warning:hover {
        background: #ebb563;
        border-color: #ebb563;
        color: #FFF;
    }
    #weekplanInfo .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before{
        float: right;
    }
    #weekplanInfo h4{
        border-bottom: none;
        margin-bottom: 0;
    }
    #weekplanInfo .el-tab-pane:after{
        content: "";
        display: block;
        height: 0;
        clear:both;
        visibility: hidden;
    }
</style>



// WEBPACK FOOTER //
// src/pages/calendar/components/weekplanInfo.vue